<div class="tw-pt-4 tw-flex tw-items-center tw-w-full" *ngIf="isFiltersPresent">
    <p class="tw-my-0 tw-mr-2 tw-whitespace-nowrap label-text">{{ 'filterDisplayComponent.appliedLabel' | transloco }}:</p>
    <ul class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-m-0 tw-p-0">
        <ng-container *ngFor="let filter of filtersArray()">
            <ng-container *ngIf="filter.values.length">
                <ng-container *ngFor="let subFilter of filter.values">
                    <li class="tw-list-none" role="listitem">
                        <p-chip 
                            label="{{ formatFilterKey(filter.key) + ': ' + (subFilter.name) }}" 
                            [removable]="true" 
                            (onRemove)="removeFilterValue(filter.key, subFilter)"
                        />
                    </li>
                </ng-container>
            </ng-container>
        </ng-container>
    </ul>
</div>
